export default (isMedApproved) => ({
    type: "VESSEL_EQUIPMENT_IS_MED_APPROVED_UPDATED",
    data: isMedApproved
});